import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const firstMeeting = [
  {
    name: 'Dr. Jaime San Pedro',
    country: 'Chile',
  },
  {
    name: 'Dra. Olga Aguilar',
    country: 'Colombia',
  },
  {
    name: 'Dr. Germán Aguilar',
    country: 'Colombia',
  },
  {
    name: 'Dra. Vania Fontanela',
    country: 'Brasil',
  },
  {
    name: 'Dr. Jorge Beltrán',
    country: 'Perú',
  },
  {
    name: 'Dra. Grethel Brown',
    country: 'Panamá',
  },
  {
    name: 'Dr. Hugo Aguayo',
    country: 'Perú',
  },
  {
    name: 'Dr. Francisco Eraso',
    country: 'Colombia / EEUU',
  },
  {
    name: 'Dra. Luisa Galván',
    country: 'México',
  },
  {
    name: 'Dr. Marino Aquino',
    country: 'México',
  },
  {
    name: 'Dra. Aurea de Freitas',
    country: 'Brasil',
  },
  {
    name: 'Dr. Claudio De Freitas',
    country: 'Brasil',
  },
  {
    name: 'Dra. Ana Luisa Berrocal',
    country: 'Costa Rica',
  },
  {
    name: 'Dra. Dinorah Álvarez',
    country: 'México',
  },
  {
    name: 'Dr. Andrés Agurto',
    country: 'Perú',
  },
  {
    name: 'Dr. Hanny González',
    country: 'Perú',
  },
  {
    name: 'Dra. Adalsa Hernández',
    country: 'Venezuela',
  },
];

const secondMeeting = [
  {
    name: 'Dra. Adalsa Hernández',
    charge: 'Presidente',
    country: 'Venezuela',
  },
  {
    name: 'Dra. Vania Fontanella',
    charge: 'Vicepresidente',
    country: 'Brasil',
  },
  {
    name: 'Dr. Claudio De Freitas',
    charge: 'Secretario',
    country: 'Brasil',
  },
  {
    name: 'Dr. Hugo Aguayo',
    charge: 'Tesorero',
    country: 'Perú',
  },
  {
    name: 'Dr. Germán Aguilar',
    charge: 'Vocal',
    country: 'Colombia',
  },
  {
    name: 'Dr. Jaime San Pedro',
    charge: 'Vocal',
    country: 'Chile',
  },
  {
    name: 'Dr. Marino Aquino',
    charge: 'Vocal',
    country: 'México',
  },
  {
    name: 'Dra. Grethel Brown',
    charge: 'Vocal',
    country: 'Panamá',
  },
  {
    name: 'Dra. Ana Luisa Berrocal',
    charge: 'Vocal',
    country: 'Costa Rica',
  },
  {
    name: 'Dr. Jorge Beltrán',
    charge: 'Suplente',
    country: 'Perú',
  },
  {
    name: 'Dra. Aurea de Freitas',
    charge: 'Suplente',
    country: 'Brasil',
  },
  {
    name: 'Dra. Helena Willhem',
    charge: 'Suplente',
    country: 'Brasil',
  },
];

export default function History() {
  return (
    <div className="xl:max-w-6xl my-24 mx-auto">
      <article className="w-full flex flex-row flex-wrap px-8">
        <div className="w-full text-gray-900 pr-4 text-justify flex flex-col flex-wrap">
          <h2 className="font-semibold text-3xl mt-4">
            Uniendo lazos con los Radiólogos latinoamericanos
          </h2>
          <div className="flex flex-row flex-wrap -mx-4 mt-4">
            <div className="w-full lg:w-3/4 px-4">
              <p>
                En el 2006, durante la Asamblea del Congreso de Radiología
                Maxilofacial realizado en Santiago de Chile, el Dr. Germán
                Aguilar propuso la formación de una Asociación que reuniera a
                todos los Odontólogos Radiólogos Latinoamericanos. EL 25 de
                Abril del 2008 en el Hotel Tamanaco, Caracas – Venezuela, en el
                marco del congreso de Radiología Dentomaxilofacial se reunieron
                representantes latinoamericanos tomando la decisión de conformar
                esta asociación. Se encontraban presentes esa reunión:
              </p>
              <div className="my-8 max-w-6xl mx-auto">
                <table className="w-full text-center px-4 py-6">
                  <thead>
                    <tr className="border-b-2 border-blue-700">
                      <th className="px-3 py-2 font-lg">Nombre</th>
                      <th className="px-3 py-2 font-lg">País</th>
                    </tr>
                  </thead>
                  <tbody>
                    {firstMeeting.map(({ name, country }) => (
                      <tr className="border-t border-blue-700" key={name}>
                        <td className="px-4 py-2 text-left">{name}</td>
                        <td className="px-4 py-2 ">{country}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="mt-4">
                El 7 de mayo de 2010, nuevamente en Caracas – Venezuela se lleva
                a cabo una reunión en la cual queda constituida la ASOCIACIÓN
                LATINOAMERICANA DE RADIOLOGÍA E IMAGENOLOGÍA DENTOMAXILOFACIAL,
                siendo la primera junta directiva conformada por:
              </p>
              <div className="my-8 max-w-6xl mx-auto">
                <table className="w-full text-center px-4 py-6">
                  <thead>
                    <tr className="border-b-2 border-blue-700">
                      <th className="px-3 py-2 font-lg">Nombre</th>
                      <th className="px-3 py-2 font-lg">Cargo</th>
                      <th className="px-3 py-2 font-lg">País</th>
                    </tr>
                  </thead>
                  <tbody>
                    {secondMeeting.map(({ name, country, charge }) => (
                      <tr className="border-t border-blue-700" key={name}>
                        <td className="px-4 py-2 text-left">{name}</td>
                        <td className="px-4 py-2 ">{charge}</td>
                        <td className="px-4 py-2 ">{country}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="w-full lg:w-1/4 px-4">
              <StaticImage
                src="../../images/alarid-logo.png"
                alt="ALARID Logo"
                className="rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </article>
      <article className="flex flex-row flex-wrap p-16 -mx-4">
        <div className="w-full md:w-1/2 p-4">
          <StaticImage
            src="../../images/alarid-1.jpg"
            alt="ALARID 1"
            className="rounded-lg shadow-2xl"
          />
        </div>
        <div className="w-full md:w-1/2 p-4">
          <StaticImage
            src="../../images/alarid-2.jpg"
            alt="ALARID 2"
            className="rounded-lg shadow-2xl"
          />
        </div>
      </article>
    </div>
  );
}
